import { Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography, useTheme } from "@mui/material";

import { useEffect, useState } from "react";
import MyTable from "../../../components/MyTable";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

import "./index.css";
import { LOANS_TO_MY_CHARGE_HISTORY_ONE, LOANS_TO_MY_CHARGE_HISTORY_THREE, LOANS_TO_MY_CHARGE_HISTORY_TWO } from "../../../constants/signalRequestConsts";
import { formatDateToTimestamp } from "../../../utils/date";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { setLoanDetails } from "../../../store/slices/documents";
import { getEmployeeLoanDetails, setLoanStatus } from "../../../api/signalApi";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MySnackbar from "../../../components/MySnackbar";
import { LoadingButton } from "@mui/lab";
// import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { DocumentsComponent } from "../../../components/DocumentsComponent";


interface TableAbsencesProps {
    requestId: (typeof LOANS_TO_MY_CHARGE_HISTORY_ONE | typeof LOANS_TO_MY_CHARGE_HISTORY_TWO |  typeof LOANS_TO_MY_CHARGE_HISTORY_THREE)

    hiddenFilterOptions?: boolean;
    allowApproveOptions?: boolean;
    setStatus?: (value: 0 | 1 | 2) => void;
    status?: 0 | 1 | 2;
    page?: number;
    setPage?: (value: number) => void;
    pageSize?: number;
    setPageSize?: (value: number) => void;
    onUpdate?: () => void
}

const TableAbsences = ({
    hiddenFilterOptions, 
    requestId, 
    allowApproveOptions, 
    setStatus, 
    status,
    page,
    setPage,
    pageSize,
    setPageSize,
    onUpdate,
}: TableAbsencesProps) => {

    const theme = useTheme();
    const dispatch = useDispatch<AppDispatch>();
    const {loans, updateStatusResult, totalItems} = useSelector((state: RootState) => state.userRequests)[requestId];
    const {paymentDetails} = useSelector((state: RootState) => state.documents.loans);
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [searchInputstring, setSearchInputstring] = useState<string>("")
    const [loanToObservate, setLoanToObservate] = useState<any>();
    const [isLoadingStatus, setIsLoadingStatus] = useState<boolean>(false)
    const [updateStatusLoanData, setUpdateStatusLoanData] = useState<null | any>(null)
    // 1: aprobado
    // 2: denegado
    const [updateLoanNewStatus, setUpdateLoanNewStatus] = useState<null | 0 | 1 | 2>(null)
    const [snackBarMsg, setSnackBarMsg] = useState<null | {msg: string, success: boolean}>(null)
    const [couponForFileViewing, setCouponForFileViewing] = useState<any | null>(null);

    const tableHeadRows = [
        {
            label: "Colaborador",
            rowKeyName: "Descripcion",
        },{
            label: "Cupón",
            rowKeyName: "CouponName",
        },{
            label: "Fecha Solicitud",
            rowKeyName: "RequestDate",
        },{
            label: "Fec. inicio",
            rowKeyName: "RangeStart",
        },{
            label: "Fec. fin",
            rowKeyName: "RangeEnd",
        },{
            label: "Cantidad",
            rowKeyName: "RangeCountString",
        }, 
    ]

    useEffect(() => {
        if (!companyselected || !connectionId) {
            return;
        }
        dispatch(setLoanDetails([]));
        if (!loanToObservate) {
            return;
        }
        getEmployeeLoanDetails(loanToObservate.NroPrestamoPersonal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected, connectionId, loanToObservate]);
    
    useEffect(() => {
        if (!updateStatusResult) {
            return;
        }
        setUpdateStatusLoanData(null)
        setUpdateLoanNewStatus(null)
        setSnackBarMsg({success: updateStatusResult.success, msg: updateStatusResult.msg})
        setIsLoadingStatus(false)
        setIsLoading(true);
        if (onUpdate) {
            onUpdate();
        }
        setIsLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateStatusResult]);

    const updateLoanStatus = async () => {
        if (!updateStatusLoanData || updateLoanNewStatus === null) {
            setSnackBarMsg({success: false, msg: "Ocurrió un error, uno de los datos no es válido."})
            return;
        }
        setIsLoadingStatus(true);
        const result = await setLoanStatus(requestId, updateStatusLoanData.NroPrestamoPersonal, updateLoanNewStatus)
        if (!result?.data?.isSuccess) {
            setUpdateStatusLoanData(null)
            setUpdateLoanNewStatus(null)
            setSnackBarMsg({success: false, msg: (result as any)?.data?.message || "Ocurrió un error con el servidor, intente nuevamente."})
        }
    }
    
    const AppovalOptions = ({row}: {row: any}) => {
        if(!allowApproveOptions) return <></>;
        return (
            <>
                <Grid 
                    container 
                    item
                    xs={12}
                    direction="row"
                    justifyContent="end"
                    sx={{
                        alignItems: "center",
                    }}
                >
                    {row.Estado === 'Por Aprobar' && <Grid item>
                        <Button
                            color="success"
                            variant="outlined"
                            style={{
                                padding: ".1rem",
                                lineHeight: "normal",
                            }}
                            onClick={() => {
                                setUpdateStatusLoanData(row);
                                setUpdateLoanNewStatus(1);
                            }}
                        >
                            Aprobar
                        </Button>
                    </Grid>}
                    {row.Estado === 'Por Aprobar' && <Grid item>
                        <Button
                            color="error"
                            variant="outlined"
                            style={{
                                padding: ".1rem",
                                lineHeight: "normal",
                                marginLeft: ".5rem"
                            }}
                            onClick={() => {
                                setUpdateStatusLoanData(row);
                                setUpdateLoanNewStatus(2);
                            }}
                        >
                            Denegar
                        </Button>
                    </Grid>}
                    {(row.Estado === 'Aprobado' && Number(row.MontoAmortizado) === 0) && <Grid item>
                        <Button
                            color="error"
                            variant="outlined"
                            style={{
                                padding: ".1rem",
                                lineHeight: "normal",
                                marginLeft: ".5rem"
                            }}
                            onClick={() => {
                                setUpdateStatusLoanData(row);
                                setUpdateLoanNewStatus(0);
                            }}
                        >
                            Volver a pendiente
                        </Button>
                    </Grid>}
                </Grid>
            </>
        )
    }
    
    const LoanOptions = ({row}: any) => {
        return (
            <Grid container direction="row" minWidth={"5rem"} justifyContent='flex-end' pr='.5rem'>
                <Grid item maxWidth="1.5rem">
                    <IconButton
                        aria-label="ver adjuntos"
                        disabled={!row.TieneNota}
                        onClick={() =>{
                            setCouponForFileViewing(row)
                        }}
                        style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            padding: ".25rem",

                            lineHeight: "1.25rem", 
                        }}
                    >
                        <AttachFileIcon
                            color={row.TieneNota 
                                ? "primary" 
                                : "disabled"
                            } 
                        />
                    </IconButton>
                </Grid>
                <Grid item maxWidth="1.5rem">
                    <IconButton
                        onClick={() => setLoanToObservate(row)}
                        aria-label="Ver documento"
                        style={{
                            color: theme.s10palette.S10Blueblue700,
                            width: "1.5rem",
                            height: "1.5rem",
                            padding: ".25rem",
                        }}
                    >
                        <VisibilityIcon />
                    </IconButton >
                </Grid>
            </Grid>
        )
    }

    return (
        <Grid item width="100%" marginTop="1.5rem" minHeight="100%">

            <MyTable
                key="tab-0"
                searchInputString={searchInputstring}
                onChangeSearchInputString={setSearchInputstring}
                totalItems={totalItems}
                totalPages={Math.ceil(totalItems / (pageSize || 10))}
                itemsPerPage={pageSize}
                pageNumber={page}
                onChangeItemsPerPage={(quantity) => {
                    if (setPageSize) setPageSize(Number(quantity))
                }}
                onChangePageNumber={(page) => {
                    if (setPage) setPage(Number(page));
                }}
                tableHeadRows={tableHeadRows}
                tableRows={loans}
                loading={isLoading}
                hiddenBottomPaginator={true} 
                hiddenFilterOptions={hiddenFilterOptions}
                cardComponent={{
                    // imageData: {
                    //     descriptionRowName: "Descripcion",
                    // },
                    className:  (row) => row.Estado === 'Aprobado'
                                            ? Number(row.MontoSaldo) === 0
                                                ? 'appoved-active'
                                                :  Number(row.MontoAmortizado) === 0
                                                    ? 'approved'
                                                    : "appoved-active"
                                            : ['Denegado', 'Rechazado'].includes(row.Estado)
                                                ? "rejected"
                                                : "pending",
                    cardContent: (row) => {
                        return (
                            <CardContent style={{padding: "0 1rem 1rem 1rem"}}>
                                <Grid container direction="row" alignItems="center" wrap="nowrap">
                                    <Typography 
                                        variant="body2" 
                                        color="text.primary"
                                        style={{
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                            flex: 1,
                                            paddingRight: '0.5rem' // Espacio entre texto e icono
                                        }}
                                    >
                                        {row.Descripcion}
                                    </Typography>
                                    
                                    <Grid item maxWidth="4rem" minWidth="2rem">
                                        <LoanOptions row={row} />
                                    </Grid>
                                    {/* <Grid item style={{ flexShrink: 0, width: '2rem' }}>
                                        <IconButton
                                            onClick={() => setLoanToObservate(row)}
                                            aria-label="Ver documento"
                                            style={{
                                                color: theme.s10palette.S10Blueblue700,
                                                minWidth: "2rem",
                                                minHeight: "2rem",
                                                padding: ".25rem",
                                            }}
                                        >
                                            <VisibilityIcon />
                                        </IconButton>
                                    </Grid> */}
                                </Grid>
                                <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                    Empresa: {" "}
                                    <Typography variant="body2" component="span">
                                        {row.Empresa}
                                    </Typography>
                                </Typography>
                                <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                    Préstamo N°: {" "}
                                    <Typography variant="body2" component="span">
                                        {row.CodPrestamoPersonal}
                                    </Typography>
                                </Typography>
                                <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                    Tipo: {" "}
                                    <Typography variant="body2" component="span">
                                        {row.TipoPrestamo}
                                    </Typography>
                                </Typography>
                                <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                    Estado: {" "}
                                    <Typography variant="body2" component="span">
                                        {row.Estado}
                                    </Typography>
                                </Typography>
                                <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                    Solicitado el: {" "}
                                    <Typography variant="body2" component="span">
                                        {`${formatDateToTimestamp(row.Fecha)}`}
                                    </Typography>
                                </Typography>
                                <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                    Observación: {" "}
                                    <Typography variant="body2" component="span">
                                        {row.Observaciones}
                                    </Typography>
                                </Typography>
                                <table 
                                    id="table-information"
                                    style={{
                                        width: "100%", 
                                        borderSpacing: "0px 0rem",
                                        borderRadius: "0.5rem",
                                    }}
                                >
                                    
                                    <tbody>
                                    {[
                                        {name: "Solicitado", value: row.MontoSolicitado}, 
                                        {name: "Otorgado", value: row.MontoOtorgado}, 
                                        {name: "Amortizado", value: row.MontoAmortizado}, 
                                        {name: "Saldo", value: row.MontoSaldo}, 
                                    ].map((row, i) => (
                                        <tr key={i} >
                                            <td>
                                            <Typography variant="body1">
                                                {row.name}
                                            </Typography>
                                            </td>
                                            <td style={{textAlign: 'end'}}>
                                            <Typography variant="body2" component="span">
                                                {Number(row.value).toFixed(2)}
                                            </Typography>
                                            </td>
                                    </tr>))}
                                    </tbody>
                                </table>
                                <Grid
                                    container
                                    padding={0}
                                    spacing={0}
                                    marginTop="1rem"
                                    direction="row"
                                >
                                    <AppovalOptions row={row}/>
                                </Grid>
                            </CardContent>
                        );
                    },
                    numberOfCards: 1,
                    changeViewOptionHidden: true,
                }}
                tableOptionsBar={{
                    useDrawer: true,
                }}
            />

            
            <Dialog
                open={loanToObservate !== undefined}
                aria-labelledby="responsive-dialog-title"
                style={{width: "100%"}}
            >
                <DialogTitle
                    id="responsive-dialog-title" 
                    style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                    variant="h5"
                >
                    Detalle de pagos
                </DialogTitle>
                <DialogContent style={{width: "100%"}}>
                    <Box display="flex" marginBottom=".5rem">
                        <Typography variant="subtitle2" color="text.primary" fontWeight="bold">
                            Monto Otorgado:{" "}
                        </Typography>
                        <Typography variant="body2" color="text.primary" ml={1}>
                            {loanToObservate?.MontoOtorgado}
                        </Typography>
                    </Box>
                    <Box display="flex" marginBottom=".5rem">
                        <Typography variant="subtitle2" color="text.primary" fontWeight="bold">
                            Monto Amortizado:{" "}
                        </Typography>
                        <Typography variant="body2" color="text.primary" ml={1}>
                            {loanToObservate?.MontoAmortizado}
                        </Typography>
                    </Box>
                    <Grid container direction="column" style={{marginTop: "1.5rem", width: "100%"}}>




                    {paymentDetails.map((item, index) => (
                        <Grid item xs={12} key={index} mb='1rem'>
                            <Card
                                // variant="outlined" 
                                sx={{ 
                                    p: 2, 
                                    position: 'relative',
                                }}
                                
                                elevation={4}
                            >
                                <CardContent>
                                    <Typography variant="subtitle1" sx={{ mb: 1.5, display: 'flex', justifyContent: 'space-between' }}>
                                        <span><strong>Cuota {item.NumeroCuota}:</strong> {item.DescripcionPeriodo}</span>
                                        {/* <Chip
                                            label={
                                                item.Estado === 1 ? 'Aprobado' :
                                                item.Estado === 2 ? 'Rechazado' :
                                                'Pendiente'
                                            }
                                            size="small"
                                            sx={{
                                                backgroundColor: item.Estado === 1 ? '#A5D6A7' :
                                                                item.Estado === 2 ? '#FFCDD2' :
                                                                '#FFF9C4',
                                                color: 'rgba(0, 0, 0, 0.87)'
                                            }}
                                        /> */}
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold' }}>Montos Amortizados</Typography>
                                        
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                            <Typography variant="body2">Cuota Normal:</Typography>
                                            <Typography variant="body2">{item.MontoAmortizado?.toFixed(2)}</Typography>
                                        </Box>
                                        
                                        {item.MontoAmortizadoDoble > 0 && (
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                            <Typography variant="body2">Cuota Doble:</Typography>
                                            <Typography variant="body2">{item.MontoAmortizadoDoble?.toFixed(2)}</Typography>
                                            </Box>
                                        )}
                                        
                                        {item.MontoAmortizadoExtraordinaria > 0 && (
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                            <Typography variant="body2">Extraordinario:</Typography>
                                            <Typography variant="body2">{item.MontoAmortizadoExtraordinaria?.toFixed(2)}</Typography>
                                            </Box>
                                        )}
                                        
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                            <Typography variant="body2">Total Amortizado:</Typography>
                                            <Typography variant="body2" fontWeight="bold">
                                            {(item.MontoAmortizado + item.MontoAmortizadoDoble + item.MontoAmortizadoExtraordinaria)?.toFixed(2)}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                            <Typography variant="body2">Saldo:</Typography>
                                            <Typography variant="body2">{item.MontoSaldo?.toFixed(2)}</Typography>
                                        </Box>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                        <Grid item xs={12} textAlign={"right"}>
                            <Button
                                variant="contained" 
                                style={{width: "8rem"}}
                                startIcon={<CheckIcon style={{height: "1rem"}} />}
                                onClick={async () => setLoanToObservate(undefined)}
                            >
                                Aceptar
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            
            {updateStatusLoanData && updateLoanNewStatus !== null && <Dialog
                open={true}
                aria-labelledby="responsive-dialog-title"
                style={{width: "100%", padding: '2rem'}}
            >
                <DialogTitle
                    id="responsive-dialog-title" 
                    style={{padding: "0", textAlign: "center", marginTop: "1.5rem"}} 
                    variant="h5"
                >
                    {updateLoanNewStatus === 1
                        ? "Aprobar" 
                        : updateLoanNewStatus === 2
                            ? "Denegar"
                            : "Volver a pendiente"
                    } préstamo
                </DialogTitle>
                <DialogContent style={{width: "100%", textAlign: "center", padding: '1rem'}}>
                    <DialogTitle 
                        id="responsive-dialog-title" 
                        style={{padding: "0", textAlign: "center"}} 
                        variant="body1"
                    >
                        ¿Seguro de {updateLoanNewStatus === 1 
                                        ? "aprobar" 
                                        : updateLoanNewStatus === 2
                                            ? "denegar"
                                            : "volver a pendiente"
                                    } el préstamo seleccionado?
                    </DialogTitle>
                </DialogContent>
                <DialogActions style={{padding: '1rem'}}>
                    <Grid container >
                        <Grid item xs={6}>
                            <LoadingButton
                                disabled={isLoadingStatus}
                                startIcon={<CloseIcon />} 
                                variant="outlined" 
                                // color="primary" 
                                onClick={() => {
                                    setUpdateStatusLoanData(null)
                                    setUpdateLoanNewStatus(null)
                                }}
                            >
                                Cancelar
                            </LoadingButton>
                        </Grid>
                        <Grid item xs={6} textAlign={"right"}>
                            <LoadingButton
                                loading={isLoadingStatus}
                                startIcon={<CheckIcon />} 
                                variant="contained" 
                                color="primary" 
                                onClick={async () => {
                                    if (isLoadingStatus) {
                                        return;
                                    }
                                    await updateLoanStatus()
                                }}
                            >
                                {updateLoanNewStatus === 1
                                    ? "Aprobar" 
                                    : updateLoanNewStatus === 2
                                        ? "Denegar"
                                        : "Volver a pendiente"
                                }
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>}
            {couponForFileViewing !== null && <Dialog
                key={couponForFileViewing.NroPrestamoPersonal}
                maxWidth="md"
                
                open={couponForFileViewing !== null}
                aria-labelledby="responsive-dialog-title"
                style={{width: "100%"}}
                PaperProps={{
                    style: {
                    width: '80%',
                    // maxWidth: '600px',   // Máximo ancho del Dialog
                    }
                }}
                fullWidth
            
            >
                <DialogTitle 
                    id="responsive-dialog-title" 
                    style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                    variant="h5"
                >
                    Documentos
                </DialogTitle>
                <DialogContent style={{width: "100%", textAlign: "center"}}>
                    <DocumentsComponent
                        groupId={couponForFileViewing.NroPrestamoPersonal} 
                        allowToDeleteFiles={false}
                        allowToAddFiles={false}
                    />
                </DialogContent>
                <DialogActions>
                    <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                        <Grid item xs={12} textAlign={"right"}>
                            <Button 
                                variant="outlined" 
                                style={{width: "8rem", margin: ".5rem",}}
                                startIcon={<CloseIcon style={{height: "1rem"}} />}
                                onClick={() => setCouponForFileViewing(null)}
                            >
                                Cerrar
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>}
            
            {snackBarMsg && <MySnackbar
                msg={snackBarMsg.msg}
                severity={snackBarMsg.success ? "success" : "error"}
                open={!!snackBarMsg.msg}
                onClose={() => {
                    setSnackBarMsg(null);
                }}
            />}

        </Grid>
    )
}

export default TableAbsences;